<nz-card class="header-card" nzSize="small" >
    <div class="flex justify-start flex-wrap gap-0 xsm:gap-2" >
      <app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
    </div>
    <div class="flex justify-between my-3">
      <h2 class="!text-lg xxsm:!text-2xl my-0">Books</h2>
    </div>
</nz-card>

  <nz-card class="!my-4" >
    <div class="max-w-[600px] w-[100%]" >
      <nz-input-group nzSearch nzSize="large"  [nzSuffix]="inputClearTpl" [nzAddOnAfter]="suffixIconButton" style="max-width: 500px">
        <input type="text"  nz-input placeholder="Search Books" [(ngModel)]="searchValue"/>
      </nz-input-group>
      <ng-template #suffixIconButton>
        <button nz-button nzType="primary" (click)="getBooksBySearch()" nzSearch><span nz-icon nzType="search"></span>Search</button>
      </ng-template>
      <ng-template #inputClearTpl>
      <span
        nz-icon
        class="ant-input-clear-icon"
        nzTheme="fill"
        nzType="close-circle"
        *ngIf="searchValue"
        (click)="cancelSearch()"
      ></span>
      </ng-template>
    </div>
  </nz-card>
<nz-empty class="mt-10" *ngIf="this.data.length === 0"></nz-empty>
  <div class="mt-4 grid-container" >
    <div class="bg-white px-4 2xl:px-5 rounded-md relative py-5" *ngFor="let book of this.data">
        <div class="flex flex-col xl:flex-row gap-4" >
          <div class="flex-shrink-0 basis-[40%] w-full h-[250px]">
            <img class="w-full object-cover h-full rounded-md" alt="Image" (error)="onImageError($event)" [src]="book.thumbnail.url"/>
          </div>
          <div class="flex-shrink-0 basis-[60%] w-full text-left flex flex-col justify-between">
            <div>
              <h4 style="margin-bottom: 0">{{book.name}}</h4>
              <h6 class="text-[#959595]">{{book.author}}</h6>
              <div class="my-4">
                <p class="my-4 font-[400]">{{this.book.description2}}</p>
              </div>
            </div>
            <div class="max-w-[200px]">
              <a [href]="book.media?.url || book.link" target="_blank">
              <button nz-button class="add-post-btn font-medium">Read Book</button>
              </a>
             
            </div>
          </div>
        </div>

    </div>








  </div>

<div class="mt-4 flex justify-end" >
  <nz-pagination class="mt-8" (nzPageIndexChange)="onCurrentPageDataChange($event)" [nzPageIndex]="currentPage" [nzTotal]="totalDocs" [nzPageSize]="pageSize"></nz-pagination>
</div>
